import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Console from './console/Console';
import Dashboard from './Dashboard';
import Login from './Login';
import Register from './Register';
import SelectSchool from './SelectSchool';

const Home = () => {
    //const lastSchool = localStorage.getItem('lastschool');
    //const defaultPath = lastSchool ? '/dashboard' : '/select-school';
    //<Route path="/" element={<Navigate to={defaultPath} replace />} />
    const defaultPath =  '/dashboard' ;

    return (
        <Routes>
            <Route path="/" element={<Dashboard />}  />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/console/*" element={<Console />} />
            <Route path="/select-school" element={<SelectSchool />} />
            <Route path="*" element={<Navigate to={defaultPath} replace />} />
        </Routes>
    );
};

export default Home;